import StytchErrorMessage from './StytchErrorMessage';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class BaseOtpPage {
    public static readonly pageId = 'otp-form';
    public static readonly otpInputId = 'otp-input';
    public static readonly submitButtonId = 'otp-submit-button';
    public static readonly errorMessageId = StytchErrorMessage.errorMessageId;
    public static readonly rememberDeviceCheckboxId =
        'otp-remember-device-checkbox';
}

export default BaseOtpPage;
